<template>
  <img src="../../../assets/img/avatars/avatar1.jpg" alt="avatar1">
</template>
